import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img1 from "./img/img1.png";
import { useNavigate } from "react-router";

export const WalkingJourney = ({ onNextStep, onTrackEvent }) => {
  const navigate = useNavigate();
  const onClick = () => {
    const hopeToAchieve = JSON.parse(localStorage.getItem("hopeToAchieve"));
    onTrackEvent();
    if (!hopeToAchieve?.includes("WEIGHT_LOSS")) {
      navigate("/onboarding/6");
    } else {
      onNextStep();
    }
  };
  

  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img1} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>Welcome to your walking journey!</h4>
          <p className={styles.description}>
            Welcome to Walky! Let's tailor your walking journey to meet your
            goals and needs.
          </p>
          <p className={styles.descriptionStrong}>
            Start hitting your goals today.
          </p>
        </div>
      </div>
      <Button variant="walky" onClick={onClick}>
        Continue
      </Button>
    </div>
  );
};
